import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { emailSendModalAsyncActions } from '@/ModalWindows/EmailSendModal/services/reducer';

export const useSelectDocumentOptions = () => {
  const dispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const selectedTypeNumbers = useSelector(emailSendModalSelectors.selectedTypeNumbers);
  const selectedEmailTemplate = useSelector(emailSendModalSelectors.selectedEmailTemplate);

  useEffect(() => {
    if (selectedTypeNumbers.length != 0 && selectedSale) {
      dispatch(
        emailSendModalAsyncActions.getDocumentsForEmail({
          orderId: selectedSale.id,
          numbers: selectedTypeNumbers,
        }),
      );
    }
  }, [selectedTypeNumbers]);

  return {
    selectedEmailTemplate,
  };
};
